import logoDark from '@/assets/logo-dark.svg';

interface LogoProps {
  width?: string | number;
  className?: string;
}

export default function Logo({ width, className }: LogoProps) {
  return <img alt="" className={className} src={logoDark} width={width} />;
}
